import React, { FunctionComponent, Fragment, useContext } from "react";
import { Theme, makeStyles, Grid, fade, lighten } from "@material-ui/core";
import { CategoryItem } from "./category-item";
import { NutritionContext } from "../../pages/nutrition/context/nutrition-context";
import { LIGHT_GRAY } from "../../theme/theme";
import { MenuItemCategory } from "../../models/types/category-types";
import { MenuCategoryDictionary } from "../../models/categories";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: theme.spacing(15),
    marginLeft: theme.spacing(20),
    maxWidth: "85px",
    backgroundColor: fade(lighten(theme.palette.background.default, 0.2), 0.5),
    boxShadow: `5px 5px 20px 5px ${LIGHT_GRAY}`,
    borderRadius: 20,
  },
}));

interface ICategoriesProps {}

export const Categories: FunctionComponent<ICategoriesProps> = (props) => {
  const classes = useStyles();
  const { activeCategory } = useContext(NutritionContext);

  return (
    <Fragment>
      <Grid container direction="column" className={classes.container}>
        {Object.values(MenuItemCategory).map((category) => {
          if (!MenuCategoryDictionary[category]?.hidden) {
            return (
              <Grid item key={category}>
                <CategoryItem category={category} active={category === activeCategory} />
              </Grid>
            );
          }
          return <Fragment key={category} />;
        })}
      </Grid>
    </Fragment>
  );
};
